// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DataGridToolbarRestoreSelectedButton.tsx
import RestoreFromTrashOutlinedIcon from "@mui/icons-material/RestoreFromTrashOutlined";
import { Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import I18n from "i18n-js";
import { DataGridToolbarProps } from "../DataGridToolbar";
import DataGridToolbarButtonContainer from "./DatagridToolbarButtonContainer";

interface DataGridToolbarRestoreSelectedButtonProps
  extends DataGridToolbarProps {}

export default function DataGridToolbarRestoreSelectedButton({
  restoreSelectedItems,
  buttonSize,
}: DataGridToolbarRestoreSelectedButtonProps) {
  return (
    <DataGridToolbarButtonContainer>
      <Tooltip title={I18n.t("App.restoreSelected")}>
        <IconButton
          size={buttonSize}
          color="success"
          style={{ marginLeft: -4 }}
          onClick={() => restoreSelectedItems && restoreSelectedItems()}
        >
          <RestoreFromTrashOutlinedIcon fontSize={buttonSize} />
        </IconButton>
      </Tooltip>
    </DataGridToolbarButtonContainer>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DataGridToolbarRestoreSelectedButton.tsx